module.exports = __webpack_public_path__ + "img/9788937832543.2aeb3429.jpg";